import * as React from 'react';
import { ActionLink } from '../../../link';
import { IconChevronDownSmall16, IconChevronUpSmall16 } from '../../../icons';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToggleButton = _ref => {
  let {
    expanded,
    onToggle,
    expandButtonText,
    collapseButtonText,
    size
  } = _ref;
  return /*#__PURE__*/_jsx(ActionLink, {
    onClick: onToggle,
    fontSize: size,
    afterIcon: expanded ? /*#__PURE__*/_jsx(IconChevronUpSmall16, {
      color: "icon-main-default"
    }) : /*#__PURE__*/_jsx(IconChevronDownSmall16, {
      color: "icon-main-default"
    }),
    spacingSize: "XS",
    "data-testid": "expander-toggle-button",
    children: expanded ? collapseButtonText : expandButtonText
  });
};